import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactMouse extends EventRegistryCategory {
    label = 'Mouse Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    click = () => new EventRegistryItem({ handlerName: 'onClick' });
    contextmenu = () => new EventRegistryItem({ handlerName: 'onContextMenu' });
    dblclick = () => new EventRegistryItem({ handlerName: 'onDoubleClick' });
    mousedown = () => new EventRegistryItem({ handlerName: 'onMouseDown' });
    mouseup = () => new EventRegistryItem({ handlerName: 'onMouseUp' });
    mouseenter = () => new EventRegistryItem({ handlerName: 'onMouseEnter' });
    mouseleave = () => new EventRegistryItem({ handlerName: 'onMouseLeave' });
    mouseover = () => new EventRegistryItem({ handlerName: 'onMouseOver' });
    mouseout = () => new EventRegistryItem({ handlerName: 'onMouseOut' });
    mousemove = () => new EventRegistryItem({ handlerName: 'onMouseMove' });
    drag = () => new EventRegistryItem({ handlerName: 'onDrag' });
    dragend = () => new EventRegistryItem({ handlerName: 'onDragEnd' });
    dragenter = () => new EventRegistryItem({ handlerName: 'onDragEnter' });
    dragexit = () => new EventRegistryItem({ handlerName: 'onDragExit' });
    dragleave = () => new EventRegistryItem({ handlerName: 'onDragLeave' });
    dragover = () => new EventRegistryItem({ handlerName: 'onDragOver' });
    dragstart = () => new EventRegistryItem({ handlerName: 'onDragStart' });
    drop = () => new EventRegistryItem({ handlerName: 'onDrop' });
}
